import {
  BIO_ALLOWED_ATTRIBUTES,
  BIO_ALLOWED_SCHEMES,
  BIO_ALLOWED_TAGS,
  BIO_LINK_REL,
  BIO_LINK_TARGET,
} from '@onesource/schemas';
import DOMPurify from 'dompurify';

const ALLOWED_URI_REGEXP = new RegExp(`^(?:${BIO_ALLOWED_SCHEMES.join('|')}):`, 'i');

const forceSafeLinks = (node: Element) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', BIO_LINK_TARGET);
    node.setAttribute('rel', BIO_LINK_REL);
  }
};

/**
 * Strict allow-list sanitizer for the Pro Directory bio (see `BIO_ALLOWED_TAGS`).
 * Unlike `sanitizeRichHtml` it permits no media, no `style`/`class`/`id`, and only
 * http(s)/mailto links, which always open in a new tab with `rel=noopener`.
 */
export const sanitizeBioHtml = (html: string): string => {
  DOMPurify.addHook('afterSanitizeAttributes', forceSafeLinks);
  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: BIO_ALLOWED_TAGS,
      ALLOWED_ATTR: BIO_ALLOWED_ATTRIBUTES['a'],
      ALLOWED_URI_REGEXP,
      ALLOW_DATA_ATTR: false,
      ALLOW_ARIA_ATTR: false,
    });
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes', forceSafeLinks);
  }
};
